import React, { SyntheticEvent, useState, useRef, Fragment } from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { SquareButton } from '../Buttons/SquareButton';
import { MenuWindow } from './MenuWindow';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {},
  dots: {
    color: theme.colors.inkSecondary,
    fontSize: theme.iconSize.large,
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
  horizontal?: boolean;
}

export const DotsMenu = ({
  children,
  className,
  horizontal,
  ...wrapperProps
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const [anchorElmnt, setAnchorElmnt] = useState<null | Element>(null);
  const idRef = useRef(`dots_menu_${Math.random()}`);

  const onClick = (event: SyntheticEvent) => {
    event.stopPropagation();
    setAnchorElmnt(event.currentTarget);
  };
  const onClose = (event: SyntheticEvent) => {
    event.stopPropagation();
    setAnchorElmnt(null);
  };

  return (
    <Fragment>
      <SquareButton
        color="ink"
        variant="transparent"
        {...wrapperProps}
        className={classnames(classes.button, className)}
        onClick={onClick}
        aria-controls={idRef.current}
        aria-haspopup="true"
        icon={horizontal ? 'ri-more-line' : 'ri-more-2-line'}
      />
      <MenuWindow
        open={!!anchorElmnt}
        onClose={onClose}
        id={idRef.current}
        anchorEl={anchorElmnt}
        onClick={onClose}
      >
        {children}
      </MenuWindow>
    </Fragment>
  );
};
